/* BF26 /pages/ofertas: product by hash (#fibra #borron #banda, none = all), shade sheet, VIP20 display, bottom gift bar */
(function () {
  var root = document.getElementById('cdbf-of');
  if (!root || !window.CDBF) return;
  var C = window.CDBF;
  var panels = root.querySelectorAll('.cdbf-of__panel');
  var dock = root.querySelector('.cdbf-dock');

  if (!C.active()) {
    panels.forEach(function (p) { p.hidden = true; });
    dock.hidden = true;
    root.querySelector('.cdbf-closed').hidden = false;
    return;
  }
  if (!C.deep()) root.querySelectorAll('.cdbf-deep').forEach(function (el) { el.remove(); });

  /* Event name in the kicker: Buen Fin (MX) / Black Friday / 48 horas más / Navidad */
  var cc = ((document.getElementById('cd-bf26') || {}).dataset || {}).country || '';
  var t = C.now(), ev;
  if (t >= Date.UTC(2026, 11, 3, 6)) ev = 'NAVIDAD';
  else if (t >= Date.UTC(2026, 11, 1, 6)) ev = '48 HORAS MÁS';
  else ev = cc === 'MX' ? 'BUEN FIN' : 'BLACK FRIDAY';
  root.querySelectorAll('.cdbf-ev').forEach(function (e) { e.textContent = ev; });

  /* VIP20: shown when the code is stored in the session (link /discount/VIP20) */
  var vip = /(?:^|;\s*)discount_code=VIP20(?:;|$)/i.test(document.cookie);
  if (vip) root.querySelectorAll('.cdbf-card__vip').forEach(function (e) { e.hidden = false; });

  /* One product when the link names it (ads, emails), all three otherwise */
  var current, single;
  function show(kind) {
    single = !!root.querySelector('#panel-' + kind);
    panels.forEach(function (p) { p.hidden = single && p.dataset.kind !== kind; });
    current = single ? kind : null;
    renderDock();
  }
  window.addEventListener('hashchange', function () { show(location.hash.slice(1)); window.scrollTo(0, 0); });

  /* Shade sheet */
  panels.forEach(function (panel) {
    var sheet = panel.querySelector('.cdbf-sheet'), shades = sheet.querySelectorAll('.cdbf-shade');
    document.body.appendChild(sheet); /* out of transformed ancestors so the fixed overlay covers the page */
    var title = sheet.querySelector('.cdbf-sheet__t'), left = sheet.querySelector('.cdbf-shades__left'), add = sheet.querySelector('.cdbf-add'), err = sheet.querySelector('.cdbf-err');
    var units = 0, counts = {}, many = panel.dataset.many, tl = panel.dataset.kind === 'banda' ? 'colores' : 'tonos';
    function total() { var s = 0; for (var k in counts) s += counts[k]; return s; }
    function render() {
      shades.forEach(function (s) { s.querySelector('.cdbf-shade__n').textContent = counts[s.dataset.id] || 0; });
      var r = units - total();
      left.textContent = r > 0 ? 'Te falta elegir ' + r : '';
      add.disabled = r !== 0;
    }
    panel.querySelectorAll('[data-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        units = +b.closest('.cdbf-card').dataset.units; counts = {}; counts[shades[0].dataset.id] = units;
        title.textContent = 'Reparte tus ' + units + ' ' + many + ' entre los ' + tl + ' que quieras';
        err.hidden = true; render();
        if (shades.length < 2) return addNow();
        sheet.hidden = false; document.documentElement.classList.add('cdbf-lock');
      });
    });
    function close() { sheet.hidden = true; document.documentElement.classList.remove('cdbf-lock'); }
    sheet.querySelectorAll('[data-close]').forEach(function (x) { x.addEventListener('click', close); });
    shades.forEach(function (s) {
      s.addEventListener('click', function (e) {
        var b = e.target.closest('.cdbf-shade__btn'); if (!b) return;
        var id = s.dataset.id, d = +b.dataset.d, n = (counts[id] || 0) + d;
        if (n < 0) return;
        if (d > 0 && total() >= units) { for (var k in counts) if (k !== id && counts[k] > 0) { counts[k]--; break; } }
        counts[id] = n; render();
      });
    });
    function addNow() {
      var items = []; for (var k in counts) if (counts[k] > 0) items.push({ id: +k, quantity: counts[k] });
      add.disabled = true; add.textContent = 'Agregando…';
      return C.addPack(items).then(close, function () { err.textContent = 'No pudimos agregar el pack. Inténtalo de nuevo.'; err.hidden = false; })
        .then(function () { add.textContent = 'Añadir al carrito'; add.disabled = false; });
    }
    add.addEventListener('click', addNow);
  });

  /* Routine kits: one bundle product per kit, the shade is the bundle variant */
  root.querySelectorAll('[data-kit-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = +btn.closest('.cdbf-kit').querySelector('[data-kit-variant]').value;
      btn.disabled = true; btn.textContent = 'Agregando…';
      C.addPack([{ id: id, quantity: 1 }]).catch(function () { btn.textContent = 'Inténtalo de nuevo'; })
        .then(function () { btn.disabled = false; if (btn.textContent === 'Agregando…') btn.textContent = 'Añadir'; });
    });
  });

  /* Bottom gift bar: units of the current tab's product in the cart */
  var counts = { fibra: 0, borron: 0, banda: 0 };
  function renderDock() {
    var kind = current;
    if (!kind) { kind = 'fibra'; for (var k in counts) if (counts[k] > counts[kind]) kind = k; }
    var panel = root.querySelector('#panel-' + kind); if (!panel) return;
    var n = counts[kind], one = panel.dataset.one, many = panel.dataset.many, g5 = panel.dataset.g5, g8 = panel.dataset.g8;
    var deep = C.deep(), max = deep ? 10 : 6;
    var steps = [[3, 'un regalo sorpresa'], [5, g5 + ' gratis']];
    if (deep) steps.push([8, g8 + ' + Neceser gratis']);
    var next = null; for (var i = 0; i < steps.length; i++) if (n < steps[i][0]) { next = steps[i]; break; }
    var msg;
    if (!n) msg = 'Regalos con tu pedido: <b>3+ ' + many + '</b> sorpresa, <b>5+</b> ' + g5 + (deep ? ', <b>8+</b> ' + g8 + ' y Neceser' : '');
    else if (next) msg = '<b>' + n + ' ' + (n > 1 ? many : one) + '</b> en tu carrito. Agrega <b>' + (next[0] - n) + ' más</b> y llévate ' + next[1] + '.';
    else msg = '<b>' + n + ' ' + many + '</b>: tienes todos los regalos desbloqueados.';
    dock.querySelector('.cdbf-dock__msg').innerHTML = msg;
    dock.querySelector('.cdbf-dock__fill').style.width = Math.min(n, max) / max * 100 + '%';
    dock.querySelectorAll('.cdbf-dock__ms').forEach(function (m) {
      m.style.left = (+m.dataset.n / max * 100) + '%';
      m.classList.toggle('is-on', n >= +m.dataset.n);
    });
  }
  function refresh() { return C.getCart().then(function (cart) { counts = C.unitsByGroup(cart); renderDock(); }); }
  document.addEventListener('cdbf:cart', function (e) { if (e.detail) { counts = e.detail; renderDock(); } });
  if (typeof window.upcartOnCartUpdated !== 'undefined') {
    var prev = window.upcartOnCartUpdated;
    window.upcartOnCartUpdated = function () { try { if (typeof prev === 'function') prev.apply(this, arguments); } catch (e) {} refresh(); };
  }

  show(location.hash.slice(1));
  refresh();
})();
